import React from "react";

export default function AnimatedSvgThing({
  timings,
  progress,
  maxOpacity = 1,
  durationMultiplier = 1,
  type = "path",
  ...props
}) {
  // const totalDuration = timings.duration * durationMultiplier;
  // const strokeDuration = totalDuration * 0.5;
  // const fillStart = strokeDuration;
  // const fillDuration = totalDuration - fillStart;

  const strokeProgress = 1;
  const fillProgress = 1;
  // const strokeProgress =
  //   progress >= strokeDuration ? 1 : progress / strokeDuration;
  // if (progress >= totalDuration) {
  //   fillProgress = 1;
  // } else if (progress > fillStart) {
  //   fillProgress = (progress - fillStart) / fillDuration;
  // }

  const allProps = {
    ...props,
    strokeLinecap: "round",
    fillOpacity: fillProgress * maxOpacity,
    pathLength: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1 - strokeProgress,
  };

  switch (type) {
    case "circle":
      return <circle {...allProps} />;
    case "rect":
      return <rect {...allProps} />;
    case "path":
      return <path {...allProps} />;
    case "ellipse":
      return <ellipse {...allProps} />;
    default:
      return <path {...allProps} />;
  }
}
